"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieDeclarationProvider = exports.CookieDeclarationContext = void 0;
var react_1 = __importStar(require("react"));
var helpers_1 = require("./helpers");
exports.CookieDeclarationContext = react_1.createContext(null);
/**
 * Provider component that sets initial state of cookie declaration, decides whether
 * it'll be opened or closed at first render and sets cookie once user selected preferrable
 * cookie settings
 */
var CookieDeclarationProvider = function (_a) {
    var cookieDomain = _a.cookieDomain, initialOpen = _a.forceOpen, _b = _a.secureCookie, secureCookie = _b === void 0 ? false : _b, _c = _a.consentChangeHandlers, consentChangeHandlers = _c === void 0 ? {} : _c, children = _a.children;
    var _d = react_1.useState(initialOpen || !helpers_1.isConsentProvided()), isOpen = _d[0], setOpen = _d[1];
    // Callbacks in setDeclaration
    var _e = react_1.useState(helpers_1.getCookieConsentState()), cookieConsent = _e[0], setCookieConsent = _e[1];
    var ref = react_1.useRef(null);
    // Callback for banner form submission
    var updateDeclaration = react_1.useCallback(function (newConsentState) {
        setCookieConsent(newConsentState);
        helpers_1.callConsentHandlers(consentChangeHandlers, cookieConsent, newConsentState);
        helpers_1.setConsentCookie(newConsentState, cookieDomain, secureCookie);
    }, [
        cookieConsent,
        setCookieConsent,
        consentChangeHandlers,
        cookieDomain,
        secureCookie,
    ]);
    /**
     * In case, when user has already accepted cookie declaration we need to run all consented onAccept handlers.
     *
     * Note that we use helper functions instead of component state, so that this effect is called only once on load.
     */
    react_1.useEffect(function () {
        if (helpers_1.isConsentProvided()) {
            var state_1 = helpers_1.getCookieConsentState();
            var consents = Object.keys(state_1);
            // filter out all declined consents and call onAccept handler, if present
            consents.filter(function (consent) { return state_1[consent]; }).forEach(function (consent) {
                var _a;
                var onAccept = ((_a = consentChangeHandlers[consent]) !== null && _a !== void 0 ? _a : {}).onAccept;
                if (onAccept) {
                    onAccept();
                }
            });
        }
        // In order to simplify the logic of this component without creating a flag to check whether this component
        // has initialized we simply ignore any changes of the props (in our case handlers),
        // so that this effect is only ran once.
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, []);
    /**
     * Callbacks that manage banner open/closed state
     */
    var open = react_1.useCallback(function () { return setOpen(true); }, []);
    var close = react_1.useCallback(function () { return setOpen(false); }, []);
    return (react_1.default.createElement(exports.CookieDeclarationContext.Provider, { value: {
            ref: ref,
            open: open,
            close: close,
            updateDeclaration: updateDeclaration,
            isOpen: isOpen,
            consentState: cookieConsent,
        } }, children));
};
exports.CookieDeclarationProvider = CookieDeclarationProvider;
